// extracted by mini-css-extract-plugin
export default {"Text_0":"StyledInputBlocks-module__Text_0--SEA41"};